'use client'

import { ShopsScreen } from '@/screens/shops'

const ShopsPageContent = () => {
	return <ShopsScreen />
}

export function ShopsClient() {
	return <ShopsPageContent />
}
